import { Component, forwardRef, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import moment from 'moment';

@Component({
  selector: 'app-form-input-editor',
  standalone: false,
  templateUrl: './form-input-editor.component.html',
  styleUrl: './form-input-editor.component.scss',
  encapsulation: ViewEncapsulation.None,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FormInputEditorComponent),
      multi: true
    }
  ]
})
export class FormInputEditorComponent implements OnInit, ControlValueAccessor {
  @Input() field: string;
  @Input() formControl: FormControl;
  @Input() height: string = '320px';
  @Input() label: string;

  public id: string;
  public value: string;

  public onChange = (_: any) => {
  };
  public onTouch = () => {
  };

  constructor() {
  }

  ngOnInit(): void {
    this.id = `${this.field}-${moment().unix()}`;
    this.value = this.formControl.value || '';
  }

  // value accessor functions
  writeValue(value: any): void {
    this.value = value || '';
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  // function to catch input changes and update form in parent
  public onInput($event: any): void {
    this.onTouch();
    this.onChange(this.replacePWithDiv($event.target?.innerHTML || ''));
  }

  // funtion to replace <p> tag with <div> tag
  private replacePWithDiv(htmlString: string): string {
    return htmlString.replace(/<p>/g, '<div>').replace(/<\/p>/g, '</div>');
  }
}
